import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Button} from '@/components/ui/button/Button'
import {useTranslation} from '@/translations/i18n'
import {useDialogContext, useDialogStore} from '@ariakit/react'
import {useFormContext} from 'react-hook-form'
import {AddPatientAbsenceFormValidationSchema} from '../../formSchemas'
import {PatientAbsenceConfirmationDialog} from '../patient-absence-confirmation-dialog/PatientAbsenceConfirmationDialog'
import {useState} from 'react'

export const AddPatientAbsenceDialogFooter = () => {
    const {t} = useTranslation()
    const [isConfirmOpen, setIsConfirmOpen] = useState(false)
    const {handleSubmit, getValues} = useFormContext<AddPatientAbsenceFormValidationSchema>()

    const parentDialogStore = useDialogContext()

    const confirmationDialogStore = useDialogStore({
        open: isConfirmOpen,
        setOpen: setIsConfirmOpen
    })

    if (!parentDialogStore) {
        throw new Error('parentDialogStore is not found')
    }

    const onConfirm = handleSubmit(
        () => {
            setIsConfirmOpen(true)
        },
        errors => {
            console.error('validation errors:', errors)
        }
    )

    return (
        <DialogFooter>
            <Flexbox gap={2} justify="end" fullWidth>
                <Button variant="secondary" onClick={() => parentDialogStore.setOpen(false)}>
                    {t('commons:close')}
                </Button>
                <Button variant="primaryNeutral" onClick={onConfirm}>
                    {t('commons:confirm')}
                </Button>
            </Flexbox>
            {isConfirmOpen && (
                <PatientAbsenceConfirmationDialog defaultValues={getValues()} dialogStore={confirmationDialogStore} />
            )}
        </DialogFooter>
    )
}
